
import dragDialog from './drag-dialog'
import preview from './preview'
import viewer from './viewer'

const installDirectives = Vue => {
  Vue.directive('drag-dialog', dragDialog)
  Vue.directive('preview', preview)
  Vue.directive('viewer', viewer)
}

export default installDirectives



// WEBPACK FOOTER //
// ./src/components/framework/directives/index.js